export const IS_PROG_LOADING = "IS_PROG_LOADING";
export const GET_PROGRAM_MAIN_CONTENT = "GET_PROGRAM_MAIN_CONTENT";
export const GET_PGDE_PAGE_CONTENT = "GET_PGDE_PAGE_CONTENT";
export const GET_NCE_PAGE_CONTENT = "GET_NCE_PAGE_CONTENT";
export const GET_BED_PAGE_CONTENT = "GET_BED_PAGE_CONTENT";
export const GET_ADE_PAGE_CONTENT = "GET_ADE_PAGE_CONTENT";
export const GET_ADEE_PAGE_CONTENT = "GET_ADEE_PAGE_CONTENT";
export const GET_PTTP_PAGE_CONTENT = "GET_PTTP_PAGE_CONTENT";
export const GET_CAPACITY_PAGE_CONTENT = "GET_CAPACITY_PAGE_CONTENT";
